import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { User } from 'src/app/modals/Authentication/auth.models';
import { Store } from '@ngrx/store';
import { RootReducerState } from '..';
import { fetchRecords } from './seasons.action';

@Injectable({ providedIn: 'root' })
export class SeasonsTableService {

    constructor(
        private store: Store<RootReducerState>,
    ) { }
 
    pagination = [];
    filters = {
                created_at: '', 
                season_name: '', 
                season_start: '', 
                season_end: '', 
                sport_association_id: null, 
            };


    page: number = 1;
    lastPage: number;
    limit: number = 10;
    initialSortColumn = 'created_at';
    initialSortDirection = 'desc';
    sortColumn = this.initialSortColumn;
    sortDirection = this.initialSortDirection;
    hasFilter = false;
    associations = [];
    columns = [
                { prop: 'created_at', name: 'COMMON.created-date', sortable: true, hasFilter: true, filter: "date", widthSet: 180},
                { prop: 'season_name', name: 'SEASON.season-name', sortable: true, hasFilter: true, filter: "input"},
                { prop: 'season_start', name: 'SEASON.season-start', sortable: true, hasFilter: true, filter: "date"},
                { prop: 'season_end', name: 'SEASON.season-end', sortable: true, hasFilter: true, filter: "date"},
                { prop: 'sport_association_id', name: 'SEASON.sports-association', sortable: true, hasFilter: true, filter: "select", options: 'associations', options_id: "id", options_label: "name"},
                { prop: 'actions', name: 'COMMON.actions', sortable: false, hasFilter: false, filter: ""},
            ];

    loadRecords() {
        this.hasFilter = this.hasActiveFilters();
        this.store.dispatch(fetchRecords());
    }

    hasActiveFilters(){
        if(
            (Object.values(this.filters).some(value => value !== '' && value !== null)) ||
            (this.sortDirection !== this.initialSortDirection || this.sortColumn !== this.initialSortColumn)
        )
            return true;
        else
            return false;        
    }

    resetFilters(){
        this.filters = {
            created_at: '', 
            season_name: '', 
            season_start: '', 
            season_end: '', 
            sport_association_id: null 
        }

        this.sortDirection = this.initialSortDirection;
        this.sortColumn = this.initialSortColumn;

        this.loadRecords();
    }

}